import { HttpService } from '@application/http.service';
import type { IdentityApiModel, SignOutApiModel, UpdateIdentityApiInput } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class IdentityApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('identity');
	}

	public isAlive() {
		return this.httpService.get<SignOutApiModel>(this.baseUri + '/isAlive');
	}

	public get() {
		return this.httpService.get<IdentityApiModel | null>(this.baseUri);
	}

	public canDeleteAccount() {
		return this.httpService.get<boolean>(this.baseUri + '/canDelete');
	}

	public deleteAccount() {
		return this.httpService.delete<boolean>(this.baseUri);
	}

	public signOut() {
		return this.httpService.post<SignOutApiModel>(this.baseUri + '/signOut', null);
	}

	public update(body: Partial<UpdateIdentityApiInput>) {
		return this.httpService.put<IdentityApiModel>(this.baseUri, body);
	}

	public getSignOutPath(returnUrl: string): string {
		const params = new URLSearchParams();
		params.append('returnUrl', returnUrl);

		// TODO: Should probably not hardcode "api" here... It won't hurt but it's a bit ugly.
		return `/api${this.baseUri}/signOutIdp?${params.toString()}`;
	}
}
